import angular from 'angular';

import ComponentModule from './component';
import LoaderComponent from './loader.cmpt';

export default angular
    .module('common.component.loader', [
        ComponentModule.name,
    ])
    .component(LoaderComponent.selector, LoaderComponent);



// WEBPACK FOOTER //
// ./src/common/component/loader/index.js